import React from 'react';
import { compose } from 'recompose';
import { withTranslations } from 'js/components/hocs/withTranslations';
import { usePortletTranslations } from 'js/components/system/Portlet';
import { getLocationParam } from 'js/utils/url.util';
import BackButton from '../BackButton';

import style from './index.scss';
import { XButton } from '../XButton/XButton';

export const HeaderBanner = ({
    widgetType,
    translationKey,
    state = 'header',
    text,
    useBackButton = false,
    backButtonUrl,
    useShape = false,
    className,
    trackXButtonClick,
    trackBackButtonClick
}) => {
    let backButtonUrllocal;
    if (backButtonUrl) {
        backButtonUrllocal = backButtonUrl.indexOf('?') !== -1 ? `${backButtonUrl}&pw=${widgetType}` : `${backButtonUrl}?pw=${widgetType}`;
    }
    const t = usePortletTranslations();
    let classes = [style.header, style[state]];
    classes = classes.join(' ');
    return (
        <div className={`${classes} ${className}`}>
            {showBackButton() && useBackButton && <BackButton trackBackButtonClick={trackBackButtonClick} character={'\u276E'} backButtonUrl={backButtonUrllocal} />}
            <XButton trackXButtonClick={trackXButtonClick} isLeaderboard={true}/>
            {useShape && <div className={style.textShape}/>}
            {!useShape && <div className={`${style.text} ${showBackButton() && useBackButton ? style.withBackButton : style.withoutBackButton}`}>
                {text || t(translationKey)}
            </div>}
        </div>
    );
};

export default compose(
    withTranslations
)(HeaderBanner);

export const showBackButton = () => getLocationParam('showBackButton') === '1';

